// Generated locally by npm run config. Do not commit this file.
export const APP_CONFIG = {
  apiBaseUrl: "https://api.dolphinarismemories.com/",
  license: "12312312321312312312312312321321"
};



// WEBPACK FOOTER //
// ./src/config/app-config.ts